<template>
  <div class="app-body">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
        ref="queryForm"
        class="query-form"
    >
      <el-form-item prop="orderCode" label="订单编号：">
        <el-input v-model="dataForm.orderCode" size="mini" clearable type="text"
                  placeholder="订单编号"></el-input>
      </el-form-item>
      <el-form-item prop="sellerName" label="发货方：">
        <el-input v-model="dataForm.sellerName" size="mini" clearable type="text"
                  placeholder="发货方"></el-input>
      </el-form-item>
      <el-form-item prop="productCode" label="品番号：" v-if="optType===20">
        <el-input
            v-model="dataForm.productCode"
            size="mini"
            clearable
            type="text"
            placeholder="品番号"
        ></el-input>
      </el-form-item>
      <el-form-item prop="skuCode" label="SKU：" v-if="optType===20">
        <el-input
            v-model="dataForm.skuCode"
            size="mini"
            clearable
            type="text"
            placeholder="SKU"
        ></el-input>
      </el-form-item>
      <el-form-item prop="nameZh" label="中文品名：" v-if="optType===20">
        <el-input
            v-model="dataForm.nameZh"
            size="mini"
            clearable
            type="text"
            placeholder="中文品名"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productName" :label="optType===10?'物料名称':'品名'">
        <el-input
            v-model="dataForm.productName"
            size="mini"
            clearable
            type="text"
            :placeholder="optType===10?'物料名称':'品名'"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productColor" label="颜色：">
        <el-input
            v-model="dataForm.productColor"
            size="mini"
            clearable
            type="text"
            placeholder="颜色"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productSize" label="规格：">
        <el-input
            v-model="dataForm.productSize"
            size="mini"
            clearable
            type="text"
            placeholder="规格"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr1" label="幅宽：" v-if="optType===10">
        <el-input
            v-model="dataForm.productAttr1"
            size="mini"
            clearable
            type="text"
            placeholder="幅宽"
        ></el-input>
      </el-form-item>
      <el-form-item prop="productAttr2" label="克重：" v-if="optType===10">
        <el-input
            v-model="dataForm.productAttr2"
            size="mini"
            clearable
            type="text"
            placeholder="克重"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button @click="reload()" size="mini">{{ $t('query') }}</el-button>
      </el-form-item>
    </el-form>
    <div class="table-bar" style="justify-content: left;margin-bottom: 0px;">
      <div class="bar-item">
        <el-button type="primary" @click="doReceive()" size="mini" v-if="$hasPermission('erp:receive:send')">确认收货
        </el-button>
      </div>
    </div>
    <SweetTable api-version="v2" ref="table" :selection="true" url="/erp/purchase/page" :query-form="dataForm">
      <el-table-column
          prop="orderCode"
          label="订单编号"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.name"
          label="物料名称"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.color"
          label="颜色"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.size"
          label="规格"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.attr1"
          label="幅宽"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          prop="product.attr2"
          label="克重"
          header-align="center"
          align="center"
          :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
          label="计划数"
          header-align="center"
          align="center"
          prop="count"
          width="100"
          fixed="right"
      >
      </el-table-column>
      <el-table-column
          label="待收货"
          header-align="center"
          align="center"
          prop="sendCount"
          width="100"
          fixed="right"
      >
      </el-table-column>
      <el-table-column
          label="已收货"
          header-align="center"
          align="center"
          prop="receiveCount"
          width="100"
          fixed="right"
      >
      </el-table-column>
      <el-table-column
          label="发货方"
          header-align="center"
          align="center"
          prop="companyName"
          fixed="right"
          width="120"
          :show-overflow-tooltip="true"
          :formatter="$c.companyNameFormatter"
      >
      </el-table-column>
    </SweetTable>
  </div>
</template>

<script>
/**
 * 来料管理,该页面提供给加工厂使用,显示所有ma_purchase收货方是当前供应商的数据
 */
import SweetTable from '@/mixins/SweetTable'

export default {
  name: 'material-receive',
  mixins: [SweetTable],
  data () {
    return {
      dateArr: [],
      currentId: '',
      dataForm: {
        orderCode: '',
        receiverName: '',
        productCode: '',
        skuCode: '',
        nameZh: '',
        productName: '',
        productColor: '',
        productSize: '',
        productAttr1: '',
        productAttr2: '',
        status: 20,
        queryType: 'receiver',
        type: ''
      },
    }
  },
  watch: {
    optType: {
      handler: function (newVal) {
        this.dataForm.type = newVal
        this.reload()
      },
      immediate: true
    }
  },
  methods: {
    //确认收货
    doReceive () {
      if (this.$c.isArrayEmpty(this.$refs.table.dataListSelections)) {
        return this.$message.error('请选择要确认收货的数据')
      }
      this.$confirm(`是否要确认收货？`, '操作提示').then(() => {
        this.$api.post(`/erp/receive/detail/client/check/receive`, { ids: this.$refs.table.dataListSelections.map(item => item.id) }).then(res => {
          this.$message.success('操作成功')
          this.getDataList()
        })
      })
    },
    beforeTableBinding (dataList) {
    },
  }
}
</script>

<style scoped>

</style>
